module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/JO-c9b2592ce6713b802abe50d87d98e602.png";